import { TableCellContent } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { EInvoiceStatusTag } from '@features/invoices/elements/EInvoiceStatusTag'
import type { EInvoiceStatus } from '@features/invoices/enums/eInvoiceStatus'
import { getEInvoiceStatusConfig } from '@features/invoices/utils/eInvoices/getEInvoiceStatusConfig'

interface EInvoiceStatusCellProps {
  eInvoiceStatus: EInvoiceStatus | null
}

export const EInvoiceStatusCell = ({ eInvoiceStatus }: EInvoiceStatusCellProps): ReactElement => {
  const { t } = useTranslation()

  if (!eInvoiceStatus) {
    return <TableCellContent>—</TableCellContent>
  }

  const config = getEInvoiceStatusConfig(eInvoiceStatus)

  if (!config) {
    return <TableCellContent>—</TableCellContent>
  }

  const { icon, labelTKey, tagColor } = config

  return <EInvoiceStatusTag color={tagColor} icon={icon} label={t(labelTKey)} />
}
